import React, { ReactElement } from 'react';
import { Link } from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import routes from '../routing/routes';

export default (): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const location = useLocation();
  return (
    <>
      <h1>Nedostatočné oprávnenia</h1>
      <p>Na zobrazenie danej stránky nemáte oprávnenie</p>
      {location.pathname !== routes.pripomienky.list.withParams(type, year, index) && (
        <p>
          <Link to={routes.pripomienky.list.withParams(type, year, index)} type="button-secondary">
            Späť na zoznam
          </Link>
        </p>
      )}
    </>
  );
};
